// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"index-module--rectangle--cbAuh","logo":"index-module--logo--16up8"};